import { render } from "./LogoutWarningDialog.vue?vue&type=template&id=08f56a08"
import script from "./LogoutWarningDialog.vue?vue&type=script&lang=js"
export * from "./LogoutWarningDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__